import React from 'react'
import { DraftTradeList } from './styles'
import { Head3 } from '../../Components/Typography/Text.styles'

export const DraftTradeItems: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <Head3>2025</Head3>
      <DraftTradeList>
        <p>March 28, 2025</p>
        <ul>
          <li>{`Pick 26: Acquired by Denver from California. California received Brendan Nichtern.`}</li>
        </ul>

        <p>March 21, 2025</p>
        <ul>
          <li>{`Pick 3: Acquired by California from Boston. California Also received Boston's 2026 4th round pick. Boston received Owen Grant.`}</li>
        </ul>

        <p>December 13th, 2024</p>
        <ul>
          <li>{`Pick 23: Acquired by Philadelphia from Maryland in addition to Zed Williams`}</li>
          <li>{`Pick 17: Acquired by Maryland from Philadelphia in addition to Matt Brandau`}</li>
        </ul>

        <p>November 7, 2024</p>
        <ul>
          <li>{`Pick 3: Acquired by Boston from Denver. Denver received Pat Kavanagh. Boston also receives the earliest 2nd round pick of Denver's in the 2026 draft.`}</li>
        </ul>

        <p>August 13, 2024</p>
        <ul>
          <li>
            {`Pick 24: Acquired by Maryland from Utah. Utah received Jackson Morrill.`}
          </li>
        </ul>

        <p>August 6, 2024</p>
        <ul>
          <li>
            {`Pick 15: Acquired by Philadelphia from Maryland. Maryland received Ryan Conrad.`}
          </li>
        </ul>

        <p>June 11, 2024</p>
        <ul>
          <li>
            {`Pick 31: Acquired by California from Maryland. Maryland received Levi Anderson.`}
          </li>
        </ul>

        <p>May 7, 2024</p>
        <ul>
          <li>
            {`Pick 18: Acquired by Archers from California. California received Utah's 2024 4th Round Pick.`}
          </li>
        </ul>

        <p>November 28, 2023</p>
        <ul>
          <li>
            {`Pick 20: Acquired by Maryland Whipsnakes from Boston Cannons - as well as 2024 3rd Round (22nd overall) & Matt Rees. Boston received Connor Kirst & Bryce Young.`}
          </li>
        </ul>
      </DraftTradeList>

      <Head3>2024</Head3>
      <DraftTradeList>
        <p>August 21, 2023</p>
        <ul>
          <li>
            {`Pick 11: Acquired by Denver from Maryland for 2024 2nd Round (11th overall) & 2024 3rd Round (19th overall). Maryland received 2024 3rd Round (17th overall) & Jackson Morrill.`}
          </li>
          <li>
            {`Pick 17: Acquired by Maryland from Denver for 2024 3rd Round (17th overall) & Jackson Morrill. Denver recieved 2024 2nd Round (11th overall) & 2024 3rd Round (19th overall).`}
          </li>
          <li>
            {`Pick 19: Acquired by Denver from Maryland for 2024 2nd Round (11th overall) & 2024 3rd Round (19th overall). Maryland received 2024 3rd Round (17th overall) & Jackson Morrill.`}
          </li>
        </ul>

        <p>November 28, 2023</p>
        <ul>
          <li>
            {`Pick 22: Acquired by Maryland Whipsnakes from Boston Cannons for a 2024 3rd Round (22nd overall), 2025 3rd Round pick, and Matt Rees. Boston Cannons received Connor Kirst and Bryce Young.`}
          </li>
        </ul>

        <p>March 15, 2024</p>
        <ul>
          <li>
            {`Pick 5: Acquired by New York from California for 2024 1st Round (5th overall). California received Chris Gray & 2024 3rd Round (18th overall).`}
          </li>
          <li>
            {`Pick 18: Acquired by California from New York for Chris Gray & 2024 3rd Round (18th overall). New York received 2024 1st Round (5th overall).`}
          </li>
        </ul>
      </DraftTradeList>
    </>
  )
}
